<template>
  <nav
    class="absolute left-1/2 top-0 z-20 flex w-full max-w-6xl -translate-x-1/2 transform items-center justify-between p-4 sm:p-6"
  >
    <NuxtLink to="/" class="block transition-all duration-300 hover:opacity-70">
      <img src="/img/logo.svg" alt="AMG" class="h-6 sm:h-8" />
    </NuxtLink>

    <!-- Desktop Navigation -->
    <div class="hidden space-x-8 text-sm md:flex lg:space-x-12">
      <NuxtLink to="#why-its-free" class="hover:text-primary hover:brightness-100">Why It's Free</NuxtLink>
      <NuxtLink to="#how-it-works" class="hover:text-primary hover:brightness-100">How It Works</NuxtLink>
      <NuxtLink to="#commercial-rights" class="hover:text-primary hover:brightness-100">
        Want Commercial Rights?
      </NuxtLink>
    </div>

    <!-- Mobile Navigation Toggle -->
    <button
      class="flex h-8 w-8 flex-col items-center justify-center space-y-1.5 transition-all duration-200 md:hidden"
      aria-label="Toggle mobile menu"
      @click="toggleMobileMenu"
    >
      <span
        class="h-0.5 w-6 bg-white transition-all duration-300"
        :class="{ 'translate-y-2 rotate-45': isMobileMenuOpen }"
      ></span>
      <span class="h-0.5 w-6 bg-white transition-all duration-300" :class="{ 'opacity-0': isMobileMenuOpen }"></span>
      <span
        class="h-0.5 w-6 bg-white transition-all duration-300"
        :class="{ '-translate-y-2 -rotate-45': isMobileMenuOpen }"
      ></span>
    </button>

    <!-- Desktop Apply Button -->
    <NuxtLink
      to="https://tally.so/r/mRQaLp"
      external
      class="bg-primary hover:bg-primary/80 focus:ring-primary/75 hidden rounded-lg px-5 py-2.5 text-xs font-semibold uppercase shadow-md transition-all duration-200 focus:ring-2 sm:px-7 sm:py-3 sm:text-sm md:block"
      aria-label="Apply for free music access"
    >
      Apply Now
    </NuxtLink>
  </nav>

  <!-- Mobile Menu Overlay -->
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-all duration-200 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isMobileMenuOpen"
      class="fixed inset-0 z-30 bg-black/80 backdrop-blur-sm md:hidden"
      @click="toggleMobileMenu"
    ></div>
  </Transition>

  <!-- Mobile Menu -->
  <Transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 scale-95 -translate-y-4"
    enter-to-class="opacity-100 scale-100 translate-y-0"
    leave-active-class="transition-all duration-200 ease-in"
    leave-from-class="opacity-100 scale-100 translate-y-0"
    leave-to-class="opacity-0 scale-95 -translate-y-4"
  >
    <div
      v-if="isMobileMenuOpen"
      class="fixed left-1/2 top-20 z-40 w-[90%] max-w-sm -translate-x-1/2 transform rounded-lg border border-gray-800 bg-black/95 p-6 shadow-2xl backdrop-blur-md md:hidden"
    >
      <div class="flex flex-col space-y-6">
        <NuxtLink
          to="#why-its-free"
          class="hover:text-primary text-lg font-medium text-white transition-colors duration-200"
          @click="toggleMobileMenu"
        >
          Why It's Free
        </NuxtLink>
        <NuxtLink
          to="#how-it-works"
          class="hover:text-primary text-lg font-medium text-white transition-colors duration-200"
          @click="toggleMobileMenu"
        >
          How It Works
        </NuxtLink>
        <NuxtLink
          to="#commercial-rights"
          class="hover:text-primary text-lg font-medium text-white transition-colors duration-200"
          @click="toggleMobileMenu"
        >
          Want Commercial Rights?
        </NuxtLink>
        <NuxtLink
          to="https://tally.so/r/mRQaLp"
          external
          class="bg-primary hover:bg-primary/80 focus:ring-primary/75 mt-3 rounded-lg px-6 py-3 text-center text-sm font-semibold uppercase shadow-md transition-all duration-200 focus:ring-2"
          aria-label="Apply for free music access"
          @click="toggleMobileMenu"
        >
          Apply Now
        </NuxtLink>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
const isMobileMenuOpen = ref(false);

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

// TODO: Disable body scroll when mobile menu is open
watch(isMobileMenuOpen, (isOpen) => {
  if (isOpen) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
});
</script>
